import React, { PureComponent } from "react";
import { Button, List, Timeline, Typography } from "antd/lib/index";
import { connect } from "react-redux";
import { Formik } from "formik";
import { bindActionCreators } from "redux";
import { submitGroupUpload } from "../../../../redux/actions/actividades";
import { selectCurrentUser } from "../../../../redux/selectors/auth";
import Attachments from "../../../../utils/Attachments";

class UploadDisplay extends PureComponent {
  render() {
    const { pregunta } = this.props;
    return (
      <Timeline>
        <Formik
          initialValues={{
            attachments: [{ mediaLink: [] }, { mediaLink: [] }]
          }}
          onSubmit={(values, { setSubmitting, setStatus }) => {
            const { groupKey, currentUser } = this.props;
            this.props.submitGroupUpload(
              groupKey,
              values,
              currentUser,
              setStatus,
              pregunta
            );
          }}
        >
          {props => {
            return (
              <React.Fragment>
                <List
                  itemLayout="vertical"
                  size="large"
                  dataSource={pregunta.preguntas}
                  renderItem={(item, i) => (
                    <Timeline.Item key={i * 40}>
                      <List.Item.Meta
                        avatar={<Typography.Title>{i + 1}</Typography.Title>}
                        title={item.titulo}
                        description={item.descripcion}
                      />
                      <Attachments
                        {...props}
                        index={i}
                        name={`attachments[${i}].mediaLink`}
                      />
                    </Timeline.Item>
                  )}
                />

                {props.status && props.status.msg && (
                  <Typography.Text type="danger">
                    {props.status.msg}
                  </Typography.Text>
                )}
                {props.status && props.status.success && (
                  <Typography.Text type="secondary">
                    {props.status.success}
                  </Typography.Text>
                )}
                <Button
                  disabled={props.isSubmitting}
                  onClick={props.handleSubmit}
                >
                  Enviarnos tu avance
                </Button>
              </React.Fragment>
            );
          }}
        </Formik>
      </Timeline>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ submitGroupUpload }, dispatch);

const mapStateToProps = (state, ownProps) => {
  const currentUser = selectCurrentUser(state);
  return {
    currentUser
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadDisplay);
